import React, { ReactElement } from 'react';
import { Table } from "semantic-ui-react"; 
import { BaseEntite, BaseEntiteSommaireStatique } from '../../../../../common/src/entities';


export interface PropsDeAprecuEntiteEnTable<TEntite extends BaseEntite> {
    model: BaseEntiteSommaireStatique<TEntite>,
    entite: TEntite
};

export default function ApercuEntiteEnTableHorizontale<TEntite extends BaseEntite>(props: PropsDeAprecuEntiteEnTable<TEntite>): ReactElement {
    const {
        model,
        entite,
    } = props;

    let properties: (keyof TEntite)[] = (Object.keys(entite) as (keyof TEntite)[]).filter((property: keyof TEntite) => {
        return (model.proprietesSommaire as (keyof TEntite)[])?.includes(property);
    });


    return (
        <Table singleLine>
          <Table.Header>
            <Table.Row>
                {
                    properties.map((property: keyof TEntite) => <Table.HeaderCell>{property}</Table.HeaderCell>)
                }
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {properties.map((property: keyof TEntite) => {
              return (
                  <Table.Cell>{entite[property]}</Table.Cell>
              );
            })}
          </Table.Body>
        </Table>
    );
};
